//#region src/index.ts
function debounce(func, opts) {
	const { delay } = opts || {};
	let timeoutId = null;
	return (args) => {
		if (timeoutId) clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			func?.(args);
		}, delay);
	};
}
function throttle(func, opts) {
	let lastInvokeTime = 0;
	const { delay = 1e3 } = opts || {};
	return (args) => {
		const now = Date.now();
		if (now - lastInvokeTime >= delay) {
			func?.(args);
			lastInvokeTime = now;
		}
	};
}

//#endregion
export { debounce, throttle };